require('dotenv').config();
import './js/fetchApi';
import './js/main';
import './js/categories';
import './js/formSignUp';
import './js/renderMarkup';
import './js/mobileMenu';
import './js/themeSwitch';
import './js/modal';
import './js/slider';
